export default "__VITE_ASSET__Cu2rBtSd__"